import { FAKE, inject, REAL, registerDependency } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { SALE_DETAIL_PAGES_FETCHER, SaleDetailPagesFetcher } from 'components/ordering/sale/api/sale-detail-pages.js'
import { createSignal } from '@cloudsuite/mosaic-shared/scripts/signals.js'

export const SALE_DETAIL_PAGES_STORE = Symbol('SALE_DETAIL_PAGES_STORE')


@registerDependency(REAL, SALE_DETAIL_PAGES_STORE)
@registerDependency(FAKE, SALE_DETAIL_PAGES_STORE)
export class SaleDetailPagesStore {
  @inject(SALE_DETAIL_PAGES_FETCHER)
  saleDetailPagesFetcher!: SaleDetailPagesFetcher

  private saleDetailPagesEndpoint?: string

  pages: () => Map<string, string>
  private setPages: (value: Map<string, string>) => void

  constructor() {
    [this.pages, this.setPages] = createSignal(new Map<string, string>())
  }

  initialize = (saleDetailPagesEndpoint: string) => {
    this.saleDetailPagesEndpoint = saleDetailPagesEndpoint
  }

  getPages = async (sale_tokens: string[]): Promise<Map<string, string>> => {
    if (this.saleDetailPagesEndpoint === undefined) {
      throw new Error('SaleDetailPagesStore not properly initialized')
    }
    const pages = await this.saleDetailPagesFetcher.getSaleDetailPages(sale_tokens, this.saleDetailPagesEndpoint)
    this.setPages(pages)
    return this.pages()
  }
}
